// extracted by mini-css-extract-plugin
module.exports = {"ModalSettings":"Tabs_ModalSettings__1EPs7"};